module.exports = __webpack_public_path__ + "img/Mask Group 159.20cf64a7.svg";